import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDropdownItem } from '@ux/menu/dropdown';
import AsyncIcon from '@ux/icon/async-icon.js';
import additionalIcons from '../icons';
import Tag from '@ux/tag';

const customIcons = additionalIcons;

const NavItem = React.forwardRef(({ as: Comp = 'div', isLink, href, active, children, icon, badge, ...rest }, forwardedRef) => {
  const {
    data: { isSelected },
    props
  } = useDropdownItem({ isLink: isLink ?? !!href, ...rest, ref: forwardedRef });

  const { className, ...sharedProps } = props;
  const cx = classnames('ux-menu-item', {
    className: !!className
  });

  if (href && Comp === 'div') {
    Comp = 'a';
  }

  let iconJsx = null;
  if (icon) {
    const CustomIcon = customIcons[icon];
    iconJsx = CustomIcon ? <CustomIcon alttext={ children } /> : <AsyncIcon icon={ icon } alttext={ children } />;
  }

  let badgeJsx = null;
  if (badge?.text) {
    badgeJsx = (
      <Tag type='highlight' size='sm'>
        { badge.text }
      </Tag>
    );
  }

  return (
    <Comp className={ cx } href={ href } { ...sharedProps } data-selected={ active || isSelected ? 'true' : undefined }>
      {iconJsx}
      {children}
      {badgeJsx}
    </Comp>
  );
});

NavItem.propTypes = {
  as: PropTypes.elementType,
  isLink: PropTypes.bool,
  href: PropTypes.string,
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.string,
  badge: PropTypes.shape({
    text: PropTypes.string
  })
};

export default NavItem;
